import React, { useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import {
  Backdrop,
  Box,
  Button,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
  Card
} from '@material-ui/core';
import PermPhoneMsgIcon from '@material-ui/icons/PermPhoneMsg';
import SendIcon from '@material-ui/icons/Send';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { baseUrl } from '../../../utils/constants';
import Controls from '../../controls/Controls';

function SelfRegSign() {
  const navigate = useNavigate();
  const [sign, setSign] = useState();
  const [url, setUrl] = useState();
  const [otp, setOtp] = useState(new Array(4).fill(''));
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });

  const handleClear = () => {
    sign.clear();
    setUrl('');
  };
  const handleGenerate = () => {
    setUrl(sign.getTrimmedCanvas().toDataURL('image/png'));
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const sendOtp = async () => {
    setLoading(true);
    const headers = {
      Authorization: `Mombez ${sessionStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    };
    const datastring = {
      cellNumber: '0827480062',
      customerUniqueIdentifier: '8C33A2B7-0164-4703-A73D-F9E511D1C89F',
      partnerRefId: null
    };
    const jsonClient = [];
    jsonClient.push(datastring);
    console.log('data otp string', jsonClient);
    axios
      .post(`${baseUrl}/api/CustomerAuthentication/sendOtp`, JSON.stringify(jsonClient[0]), {
        headers
      })
      .then(
        (result) => {
          setLoading(false);
          if (result.data.replyStatus === 0) {
            notifyPopup('OTP Sent Successfully!', 'success');
          } else {
            notifyPopup(
              `Error in Sending Otp, Please try resend again!: ${result.data.replyMessage}`,
              'error'
            );
          }
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Sending Otp!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const acceptOtp = (otpEntered) => {
    console.log('url is:', url);
    if (url === undefined || url === null || url === '') {
      notifyPopup(
        `Please sign in box above and click Save before accepting the OTP!: ${otpEntered}`,
        'error'
      );
      return;
    }
    if (otpEntered === '8888') {
      navigate(`/redirect`);
    } else {
      notifyPopup(`The Entered OTP is Incorrect, Please try again!: ${otpEntered}`, 'error');
    }
  };

  const handleOtpChange = (element, index) => {
    if (Number.isNaN(element.value)) return false;

    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

    // Focus next input
    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  return (
    <Box>
      <Box style={{ border: '2px solid black', width: 500, height: 200 }}>
        <SignatureCanvas
          canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }}
          ref={(data) => setSign(data)}
        />
      </Box>

      <br />
      <Button
        type="button"
        variant="contained"
        color="error"
        style={{ height: '30px', width: '80px' }}
        onClick={handleClear}
      >
        Clear
      </Button>
      <Button
        type="button"
        variant="contained"
        color="secondary"
        sx={{ height: '30px', width: '80px', ml: '4px' }}
        onClick={handleGenerate}
      >
        Save
      </Button>
      <Button
        type="button"
        variant="contained"
        sx={{
          height: '30px',
          width: '160px',
          ml: '4px',
          color: 'white',
          backgroundColor: '#000000'
        }}
        onClick={handleGenerate}
      >
        Print and Sign
      </Button>

      <br />
      <br />
      <img alt="signature" src={url} />
      <Typography variant="h6" align="center" sx={{ fontWeight: 'bold', mb: '2px' }}>
        Verify Otp...
      </Typography>
      <Card sx={{ mb: '2rem' }}>
        <CardContent>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
            onClick={handleLoadingClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Box display="flex">
            <Box flex="1 1 0" minWidth="0px" mr={1} justifyContent="center" alignItems="center">
              <Grid
                container
                margin={1}
                direction="column"
                justifyContent="center"
                alignItems="center"
              >
                <p>
                  Please Enter the OTP sent to you to Accept the Membership Deduction (use 8888)
                </p>
              </Grid>
              <Grid
                container
                margin={1}
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                {otp.map((data, index) => (
                  <input
                    style={{
                      height: 50,
                      margin: 10,
                      width: '15%',
                      textAlign: 'center',
                      fontSize: 35
                    }}
                    type="string"
                    name="otp"
                    key={index}
                    value={data}
                    onChange={(e) => handleOtpChange(e.target, index)}
                    onFocus={(e) => e.target.select()}
                  />
                ))}
              </Grid>

              <Grid
                container
                margin={1}
                mt={4}
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={12} sm={2} style={{ textAlign: 'center' }}>
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={() => acceptOtp(otp.join(''))}
                    // onClick={() => acceptOtp()}
                    startIcon={<PermPhoneMsgIcon />}
                  >
                    Verify Otp...
                  </Button>
                </Grid>
                <Grid item xs={12} sm={2} style={{ textAlign: 'center' }}>
                  <Button
                    type="button"
                    variant="outlined"
                    color="error"
                    startIcon={<SendIcon />}
                    onClick={() => sendOtp()}
                  >
                    Resend Otp...
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Controls.Notification notify={notify} setNotify={setNotify} />
        </CardContent>
      </Card>
    </Box>
  );
}
export default SelfRegSign;
